import { formatCurrency } from '@/utils/helpers';

/** When `oloVoucherPrintLabels` is absent from config, use this default (legacy behavior). */
export const DEFAULT_OLO_VOUCHER_LABELS = ['VOUCHER'];

/**
 * Normalized uppercase trigger labels from config.
 * Missing/null config key → default `VOUCHER`.
 * Explicit empty array → no triggers (voucher printing disabled).
 */
export function getOloVoucherTriggerLabels(config) {
  const raw = config?.oloVoucherPrintLabels;
  if (raw === undefined || raw === null) {
    return [...DEFAULT_OLO_VOUCHER_LABELS];
  }
  if (!Array.isArray(raw)) {
    return [...DEFAULT_OLO_VOUCHER_LABELS];
  }
  return raw
    .map((s) => String(s || '').trim())
    .filter(Boolean)
    .map((s) => s.toUpperCase());
}

/**
 * True if the menu item should print a voucher chit (customLabels or tags match any trigger).
 */
export function menuItemMatchesVoucherTriggers(menuItem, normalizedTriggerLabels) {
  if (!menuItem || !normalizedTriggerLabels.length) return false;
  const tags = menuItem.tags || [];
  const labels = menuItem.customLabels || [];
  const combined = [...tags, ...labels]
    .map((x) => String(x || '').trim().toUpperCase())
    .filter(Boolean);
  return combined.some((c) => normalizedTriggerLabels.includes(c));
}

/**
 * Receipt payload lines for Shift4Kiosk voucher chit (OLO).
 */
export function buildOloVoucherChitLines({ itemName, valueCents }) {
  const valueText = formatCurrency(valueCents);
  return [
    { type: 'Text', text: '================================', align: 'CENTER', bold: true, size: 'NORMAL' },
    { type: 'Empty', count: 2 },
    { type: 'Text', text: 'VOUCHER', align: 'CENTER', bold: true, size: 'DOUBLE' },
    { type: 'Empty', count: 1 },
    { type: 'Text', text: valueText, align: 'CENTER', bold: true, size: 'DOUBLE' },
    { type: 'Empty', count: 1 },
    { type: 'Text', text: (itemName || '').toUpperCase(), align: 'CENTER', bold: true, size: 'LARGE' },
    { type: 'Empty', count: 2 },
    { type: 'Text', text: '================================', align: 'CENTER', bold: true, size: 'NORMAL' },
    { type: 'Empty', count: 3 },
  ];
}

export function buildOloVoucherChitPayload({ itemName, valueCents, printerWidth }) {
  return {
    gutter: 2,
    printerWidth: printerWidth || 48,
    lines: buildOloVoucherChitLines({ itemName, valueCents }),
  };
}
